export interface DamageResult { readonly applied: boolean; readonly previous: number; readonly current: number; readonly reachedZero: boolean; }

export class GhostHealthComponent {
  private hp: number;
  private readonly processedHits = new Set<string>();
  constructor(readonly maximum: number, private readonly onChanged: (current: number, maximum: number) => void = () => {}, private readonly onZero: () => void = () => {}) {
    this.hp = maximum;
  }
  get current(): number { return this.hp; }
  get isEmpty(): boolean { return this.hp === 0; }
  damage(amount: number, hitId: string): DamageResult {
    const previous = this.hp;
    if (amount <= 0 || this.hp === 0 || this.processedHits.has(hitId)) return { applied: false, previous, current: this.hp, reachedZero: false };
    this.processedHits.add(hitId); this.hp = Math.max(0, this.hp - amount); this.onChanged(this.hp, this.maximum);
    const reachedZero = previous > 0 && this.hp === 0; if (reachedZero) this.onZero();
    return { applied: true, previous, current: this.hp, reachedZero };
  }
  reset(): void { this.hp = this.maximum; this.processedHits.clear(); this.onChanged(this.hp, this.maximum); }
}

export type CaptureWindowOutcome = "running" | "expired" | "locked" | "inactive";
export class CaptureWindow {
  private remainingTime = 0;
  private active = false;
  private outcomeLocked = false;
  constructor(readonly durationSeconds = 5) {}
  get remaining(): number { return Math.max(0, this.remainingTime); }
  get secondsDisplay(): number { return Math.max(0, Math.ceil(this.remaining)); }
  get isActive(): boolean { return this.active; }
  get isLocked(): boolean { return this.outcomeLocked; }
  start(): void { this.remainingTime = this.durationSeconds; this.active = true; this.outcomeLocked = false; }
  lockCapture(): boolean { if (!this.active || this.remainingTime <= 0) return false; this.outcomeLocked = true; this.active = false; return true; }
  update(deltaSeconds: number): CaptureWindowOutcome {
    if (this.outcomeLocked) return "locked";
    if (!this.active) return "inactive";
    this.remainingTime = Math.max(0, this.remainingTime - Math.max(0, deltaSeconds));
    if (this.remainingTime === 0) { this.active = false; return "expired"; }
    return "running";
  }
}
